import { render, staticRenderFns } from "./ListingFeatures.vue?vue&type=template&id=54b6b808"
import script from "./ListingFeatures.vue?vue&type=script&lang=js"
export * from "./ListingFeatures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports